import { Box, Typography } from '@mui/material';

import {
  DURATION_TRIAL_TIME_ROOT_SX,
  DURATION_TRIAL_TIME_SEPARATOR_SX,
  DURATION_TRIAL_TIME_UNIT_SX,
  DURATION_TRIAL_TIME_VALUE_SX,
} from './styles';

import type { FHDurationTrialTimeProps } from './types';

export default function FHDurationTrialTime({ seconds }: FHDurationTrialTimeProps) {
  return (
    <Box sx={DURATION_TRIAL_TIME_ROOT_SX}>
      <Typography sx={DURATION_TRIAL_TIME_VALUE_SX}>
        {String(Math.floor(seconds / 3600)).padStart(2, '0')}
      </Typography>
      <Typography sx={DURATION_TRIAL_TIME_UNIT_SX}>h</Typography>
      <Typography sx={DURATION_TRIAL_TIME_SEPARATOR_SX}> : </Typography>
      <Typography sx={DURATION_TRIAL_TIME_VALUE_SX}>
        {String(Math.floor((seconds % 3600) / 60)).padStart(2, '0')}
      </Typography>
      <Typography sx={DURATION_TRIAL_TIME_UNIT_SX}>m</Typography>
      <Typography sx={DURATION_TRIAL_TIME_SEPARATOR_SX}> : </Typography>
      <Typography sx={DURATION_TRIAL_TIME_VALUE_SX}>
        {String(seconds % 60).padStart(2, '0')}
      </Typography>
      <Typography sx={DURATION_TRIAL_TIME_UNIT_SX}>s</Typography>
    </Box>
  );
}
